export const internallinks = [
  {
    path: "tomma-dodsbo-goteborg",
    title: "Tömma dödsbo Göteborg"
  },
  {
    path: "koper-dodsbo-goteborg",
    title: "Köper dödsbo Göteborg"
  },
  {
    path: "uppkop-dodsbo-goteborg",
    title: "Uppköp dödsbo Göteborg"
  },
  {
    path: "salja-dodsbo-goteborg",
    title: "Sälja dödsbo Göteborg"
  },
  {
    path: "vardera-dodsbo-goteborg",
    title: "Värdera dödsbo Göteborg"
  },
  {
    path: "hjalp-dodsbo-goteborg",
    title: "Hjälp dödsbo Göteborg"
  },
  {
    path: "bortforsling-dodsbo-goteborg",
    title: "Bortforsling dödsbo Göteborg"
  },
  {
    path: "dodsbo-goteborg",
    title: "Dödsbo Göteborg"
  },
  {
    path: "vardera-dodsbo-hisingen",
    title: "Värdera dödsbo Hisingen"
  },
  {
    path: "tomma-dodsbo-hisingen",
    title: "Tömma dödsbo Hisingen"
  },
  {
    path: "salja-dodsbo-hisingen",
    title: "Sälja dödsbo Hisingen"
  },
  {
    path: "uppkop-dodsbo-hisingen",
    title: "Uppköp dödsbo Hisingen"
  },
  {
    path: "bortforsling-dodsbo-hisingen",
    title: "Bortforsling dödsbo Hisingen"
  },
  {
    path: "uppkop-av-bohag",
    title: "Uppköp av bohag"
  },
  {
    path: "uppkop-av-dodsbo",
    title: "Uppköp av dödsbo"
  },
  {
    path: "roja-dodsbo-goteborg",
    title: "Röja dödsbo Göteborg"
  },
  {
    path: "stada-dodsbo-goteborg",
    title: "Städa dödsbo Göteborg"
  },
  {
    path: "vardera-dodsbo-kungsbacka",
    title: "Värdera dödsbo Kungsbacka"
  },
  {
    path: "bortforsling-dodsbo-partille",
    title: "Bortforsling dödsbo Partille"
  },
  {
    path: "salja-dodsbo-partille",
    title: "Sälja dödsbo Partille"
  },
  {
    path: "kopa-dodsbo-partille",
    title: "Köpa dödsbo Partille"
  },
  {
    path: "rojer-dodsbo-partille",
    title: "Röjer dödsbo Partille"
  },
  {
    path: "stada-dodsbo-partille",
    title: "Städa dödsbo Partille"
  },
  {
    path: "uppkop-dodsbo-partille",
    title: "Uppköp dödsbo Partille"
  },
  {
    path: "flyttstadning-trollhattan",
    title: "Flyttstädning Trollhättan"
  },
  {
    path: "dodsbo-trollhattan",
    title: "Dödsbo Trollhättan"
  },
  {
    path: "dodsbo-kopes-trollhattan",
    title: "Dödsbo köpes Trollhättan"
  },
  {
    path: "bortforsling-dodsbo-trollhattan",
    title: "Bortforsling dödsbo Trollhättan"
  },
  {
    path: "vardera-dodsbo-trollhattan",
    title: "Värdera dödsbo Trollhättan"
  },
  {
    path: "salja-dodsbo-trollhattan",
    title: "Sälja dödsbo Trollhättan"
  },
  {
    path: "tomma-dodsbo-trollhattan",
    title: "Tömma dödsbo Trollhättan"
  },
  {
    path: "stadning-av-dodsbo-trollhattan",
    title: "Städning av dödsbo Trollhättan"
  },
  {
    path: "flyttstadning-dodsbo-boras",
    title: "Flyttstädning dödsbo Borås"
  },
  {
    path: "/stadar-dodsbo-alingsas",
    title: "Städar dödsbo Alingsås"
  },
  {
    path: "/koper-dodsbo-alingsas",
    title: "Köper dödsbo Alingsås"
  },
  {
    path: "/tomma-dodsbo-alingsas",
    title: "Tömma dödsbo Alingsås"
  },
  {
    path: "/vardera-dodsbo-alingsas",
    title: "Värdera dödsbo Alingsås"
  }
];

export const popularLinks = [
  {
    path: "vardera-dodsbo-ulricehamn",
    title: "Värdera dödsbo Ulricehamn"
  },
  {
    path: "hjalp-dodsbo-ulricehamn",
    title: "Hjälp dödsbo Ulricehamn"
  },
  {
    path: "bortforsling-dodsbo-ulricehamn",
    title: "Bortforsling dödsbo Ulricehamn"
  },
  {
    path: "salja-dodsbo-ulricehamn",
    title: "Sälja dödsbo Ulricehamn"
  },
  {
    path: "tomma-dodsbo-ulricehamn",
    title: "Tömma dödsbo Ulricehamn"
  },
  {
    path: "uppkop-dodsbo-ulricehamn",
    title: "Uppköp dödsbo Ulricehamn"
  },
  {
    path: "uppkop-dodsbo-ale",
    title: "Uppköp dödsbo Ale"
  },
  {
    path: "bortforsling-dodsbo-ale",
    title: "Bortforsling dödsbo Ale"
  },
  {
    path: "salja-dodsbo-ale",
    title: "Sälja dödsbo Ale"
  },
  {
    path: "vardera-dodsbo-ale",
    title: "Värdera dödsbo Ale"
  },
  {
    path: "tomma-dodsbo-molndal",
    title: "Tömma dödsbo Mölndal"
  },
  {
    path: "bortforsling-dodsbo-molndal",
    title: "Bortforsling dödsbo Mölndal"
  },
  {
    path: "dodsbo-firma-molndal",
    title: "Dödsbo firma Mölndal"
  },
  {
    path: "kopa-dodsbo-molndal",
    title: "Köpa dödsbo Mölndal"
  },
  {
    path: "roja-dodsbo-molndal",
    title: "Röja dödsbo Mölndal"
  },
  {
    path: "salja-dodsbo-molndal",
    title: "Sälja dödsbo Mölndal"
  },
  {
    path: "stada-dodsbo-molndal",
    title: "Städa dödsbo Mölndal"
  },
  {
    path: "bortforsling-dodsbo-stenungsund",
    title: "Bortforsling dödsbo Stenungsund"
  },
  {
    path: "roja-dodsbo-stenungsund",
    title: "Röja dödsbo Stenungsund"
  },
  {
    path: "kopa-dodsbo-stenungsund",
    title: "Köpa dödsbo Stenungsund"
  },
  {
    path: "salja-dodsbo-stenungsund",
    title: "Sälja dödsbo Stenungsund"
  },
  {
    path: "tomma-dodsbo-stenungsund",
    title: "Tömma dödsbo Stenungsund"
  },
  {
    path: "vardera-dodsbo-stenungsund",
    title: "Värdera dödsbo Stenungsund"
  },
  {
    path: "tommer-lagenheter-boras",
    title: "Tommer lägenheter Borås"
  },
  {
    path: "slutstadning-dodsbo-boras",
    title: "Slutstädning dödsbo Borås"
  },
  {
    path: "salja-dodsbo-boras",
    title: "Sälja dödsbo Borås"
  },
  {
    path: "kopa-dodsbo-boras",
    title: "Köpa dödsbo Borås"
  },
  {
    path: "roja-dodsbo-boras",
    title: "Röja dödsbo Borås"
  },
  {
    path: "bortforsling-dodsbo-boras",
    title: "Bortforsling dödsbo Borås"
  },
  {
    path: "dodsbo-firma-boras",
    title: "Dödsbo firma Borås"
  },
  {
    path: "dodsbo-tomning-boras",
    title: "Dödsbo tömning Borås"
  },
  {
    path: "tomma-hus-kungsbacka",
    title: "Tömma hus Kungsbacka"
  }
];

export const fleromrodenLinks = [
  {
    path: "flyttfirma/flyttfirma-goteborg",
    title: "Flyttfirma Göteborg"
  },
  {
    path: "flyttfirma/flyttfirma-kungalv",
    title: "Flyttfirma Kungälv"
  },
  {
    path: "flyttfirma/flyttfirma-boras",
    title: "Flyttfirma Borås"
  },
  {
    path: "flyttfirma/billig-flyttfirma-goteborg",
    title: "Billig flyttfirma Göteborg"
  },
  {
    path: "flyttfirma/flyttfirma-offert",
    title: "Flyttfirma Offert"
  },
  {
    path: "tommer-hushall",
    title: "Tömmer hushåll"
  },
  {
    path: "tommer-hem",
    title: "Tömmer hem"
  },
  {
    path: "tommer-hem-goteborg",
    title: "Tömmer hem i Göteborg"
  },
  {
    path: "tommer-hushall-goteborg",
    title: "Tömmer hushåll i Göteborg"
  },
  {
    path: "vardera-dodsbo-kungalv",
    title: "Värdera dödsbo Kungälv"
  },
  {
    path: "hjalp-dodsbo-kungalv",
    title: "Hjälp dödsbo Kungälv"
  },
  {
    path: "bortforsling-dodsbo-kungalv",
    title: "Bortforsling dödsbo Kungälv"
  },
  {
    path: "salja-dodsbo-kungalv",
    title: "Sälja dödsbo Kungälv"
  },
  {
    path: "tomma-dodsbo-kungalv",
    title: "Tömma dödsbo Kungälv"
  },
  {
    path: "uppkop-dodsbo-kungalv",
    title: "Uppköp dödsbo Kungälv"
  },
  {
    path: "uppkop-dodsbo-frolunda",
    title: "Uppköp dödsbo Frölunda"
  },
  {
    path: "salja-dodsbo-frolunda",
    title: "Sälja dödsbo Frölunda"
  },
  {
    path: "tomma-dodsbo-frolunda",
    title: "Tömma dödsbo Frölunda"
  },
  {
    path: "vardera-dodsbo-frolunda",
    title: "Värdera dödsbo Frölunda"
  },
  {
    path: "bortforsling-dodsbo-frolunda",
    title: "Bortforsling dödsbo Frölunda"
  },
  {
    path: "dodsbo-uppkopare-goteborg",
    title: "Dödsbo uppköpare Göteborg"
  },
  {
    path: "tommer-dodsbo",
    title: "Tömmer dödsbo"
  },
  {
    path: "dodsbofirma",
    title: "Dödsbo firma"
  },
  {
    path: "tomma-dodsbo",
    title: "Tömma Dödsbo"
  },
  {
    path: "tomma-dodsbo-ale",
    title: "Tömma dödsbo Ale"
  },
  {
    path: "dodsbo-uppkopare",
    title: "Dödsbo uppköpare"
  },
  {
    path: "foretag-som-koper-bohag",
    title: "Företag som köper bohag"
  },
  {
    path: "bortforsling-dodsbo-kungsbacka",
    title: "Bortforsling dödsbo Kungsbacka"
  },
  {
    path: "dodsbo-firma-kungsbacka",
    title: "Dödsbo firma Kungsbacka"
  },
  {
    path: "hamtar-dodsbo-kungsbacka",
    title: "Hämtar dödsbo Kungsbacka"
  },
  {
    path: "koper-dodsbo-kungsbacka",
    title: "Köper dödsbo Kungsbacka"
  },
  {
    path: "salja-dodsbo-kungsbacka",
    title: "Sälja dödsbo Kungsbacka"
  },
  {
    path: "tomma-dodsbo-kungsbacka",
    title: "Tömma dödsbo Kungsbacka"
  },
  {
    path: "tommer-dodsbo-kungsbacka",
    title: "Tömmer dödsbo Kungsbacka"
  },
  {
    path: "tomma-dodsbo-boras",
    title: "Tömma dödsbo Borås"
  },
  {
    path: "vardera-dodsbo-boras",
    title: "Värdera dödsbo Borås"
  },
  {
    path: "uppkop-dodsbo-boras",
    title: "Uppköp dödsbo Borås"
  },
  {
    path: "vardering-av-dodsbo",
    title: "Värdering av dödsbo"
  },
  {
    path: "flyttstadning",
    title: "Flyttstädning"
  },
  {
    path: "flyttstadning-i-goteborg",
    title: "Flyttstädning i Göteborg"
  },
  {
    path: "flyttstadning-i-kungalv",
    title: "Flyttstädning i Kungälv"
  },
  {
    path: "/bohagsflytt",
    title: "Bohagsflytt"
  },
  {
    path: "/vardera-dodsbo",
    title: "Värdera dödsbo"
  }
];
